// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"BM-z","carouselContainer":"CM-z"};